<script>
export default {
  name: "TextWithLines",
  props: {
    text: { type: String, required: true },
  },
};
</script>

<template>
  <div class="text-with-lines">
    <div class="line"></div>
    {{ text }}
    <div class="line"></div>
  </div>
</template>

<style scoped lang="scss">
.text-with-lines {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--theme-color-medium);

  .line {
    flex: 1;
    height: 0.5px;
    background-color: var(--theme-color-light);
  }
}
</style>
